module.exports = __webpack_public_path__ + "static/media/course2.25339c21.png";